import React from "react"
import moment from "moment"
import { Button, DatePicker, Form, Select } from "antd"
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons"
import styled from "styled-components"

const GROUPS = [
  { value: "day", label: "По дням" },
  { value: "week", label: "По неделям" },
  { value: "month", label: "По месяцам" },
]

export function ReportFilters({ period, categories, onSearch, onExport, canExport, isExporting }) {
  const [form] = Form.useForm()

  function onFinish(values) {
    onSearch({
      dateFrom: values.range[0].format("YYYY-MM-DD"),
      dateTo: values.range[1].format("YYYY-MM-DD"),
      group: values.group,
      categories: values.categories ?? [],
    })
  }

  const categoryOptions = categories.map((category) => ({ value: category.key, label: category.label }))

  return (
    <StyledForm
      form={form}
      layout="inline"
      onFinish={onFinish}
      initialValues={{
        range: [moment(period.dateFrom), moment(period.dateTo)],
        group: period.group,
        categories: period.categories,
      }}
    >
      <Form.Item name="range" label="Период" rules={[{ required: true, message: "Укажите период" }]}>
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          allowClear={false}
          disabledDate={(date) => date && date.isAfter(moment(), "day")}
        />
      </Form.Item>
      <Form.Item name="group" label="Группировка">
        <Select options={GROUPS} style={{ width: 140 }} />
      </Form.Item>
      <Form.Item name="categories" label="Категории">
        <Select
          mode="multiple"
          allowClear
          placeholder="Все"
          options={categoryOptions}
          style={{ minWidth: 260 }}
          maxTagCount="responsive"
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" icon={<ReloadOutlined />}>
          Показать
        </Button>
      </Form.Item>
      {canExport && (
        <Form.Item>
          <Button icon={<DownloadOutlined />} onClick={onExport} loading={isExporting}>
            Выгрузить CSV
          </Button>
        </Form.Item>
      )}
    </StyledForm>
  )
}

const StyledForm = styled(Form)`
  row-gap: 12px;
  margin-bottom: 16px;
`
